module.exports = __webpack_public_path__ + "media/images/new/public_land_map_overlays@2x-bf619eb9b61bc57562e50ed73358d0cc.jpg";